import React from 'react'
import PropTypes from "prop-types";
import { useTheme, withStyles } from '@material-ui/core/styles';

import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

const ClubListItem = React.forwardRef((props, ref) => {

    const { club, ...rest } = props

    const theme = useTheme();

    const StyledAvatar = withStyles({
        colorDefault: {
            backgroundColor: club.branding.primary_color,
            color: theme.palette.getContrastText(club.branding.primary_color),
        },
        img: {
            objectFit: 'contain'
        }
    })(Avatar);

    return (
        <ListItem {...rest} ref={ref} alignItems="flex-start">
            <ListItemAvatar>
                <StyledAvatar
                    src={club.branding.icon ? club.branding.icon.full_url : null}
                    alt={club.name}
                    variant="rounded"
                    >
                    {club.branding.acronym_short}
                </StyledAvatar>
            </ListItemAvatar>
            <ListItemText primary={club.name} secondary={club.description} />
        </ListItem>
    )

});

ClubListItem.propTypes = {
    club: PropTypes.object.isRequired,
};

export default ClubListItem;
